/**
 * 挂牌交易
 */
import { post } from "./http";

let basic = "/ngList";

const listApi = {
  getListing: (params) => {
    return post(`${basic}/listPage`, params);
  }, // 挂牌列表
  createNgListOrder: (params) => {
    return post(`${basic}/createNgListOrder`, params);
  }, //挂牌下单
  listingDetail: (params) => {
    return post(`${basic}/listDetail`, params);
  }, // 挂牌详情
  batchUpAndDown: (params) => {
    return post(`${basic}/batchUpAndDown`, params);
  }, // 上架下架
  listOperateRecord: (params) => {
    return post(`${basic}/listOperateRecord`, params);
  }, //历史纪录
  listingremove: (params) => {
    return post(`${basic}/remove`, params);
  }, // 删除挂牌
  getAgreement: (params) => {
    return post(`/merchant/listAgreement`, params);
  }, // 协议
  getOptimalPrice: (params) => {
    return post(`/order/lng/getOptimalPrice`, params);
  }, // 获取优惠价格
  tradeTypeSearch: (params) => {
    return post(`/trade/ng/tradeTypeSearch`, params);
  }, // 挂牌筛选大厅
};

export default listApi;
